import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/api';
import { Container, Table } from './styles';

import Button from '../../components/Button';
import Loading from '../../components/Loading';

export default class Promoters extends Component {
  state = {
    loading: true,
    promoters: [],
  };

  genreTranslation = {
    male: 'Masculino',
    female: 'Feminino',
  };

  componentDidMount() {
    this.loadPromoters();
  }

  loadPromoters = async () => {
    try {
      const { data } = await api.get('favorite_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      data.promoters = data.promoters.map(promoter => ({
        ...promoter,
        genre: this.genreTranslation[promoter.genre],
      }));
      this.setState({ promoters: data.promoters });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ promoters: [] });
    }
  };

  deleteFavorite = async (id) => {
    const { promoters } = this.state;
    try {
      await api.delete(`favorite_promoters/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({ promoters: promoters.filter(promoter => promoter.id !== id) });
    } catch (err) {
      this.setState({ promoters: [] });
    }
  };

  render() {
    const { loading, promoters } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">Divulgadores favoritos</h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {promoters.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Gênero</th>
                            <th>Cidade</th>
                            <th>Instagram</th>
                            <th>Nº de seguidores</th>
                            <th>Engajamento</th>
                            <th>Nota média</th>
                            <th>Remover dos favoritos</th>
                          </tr>
                        </thead>
                        <tbody>
                          {promoters.map(promoter => (
                            <tr key={promoter.id}>
                              <td>
                                <div
                                  className="profile-image"
                                  style={
                                    promoter.avatar.url && {
                                      backgroundImage: `url(${promoter.avatar.url})`,
                                    }
                                  }
                                />
                              </td>
                              <td>{promoter.name}</td>
                              <td>{promoter.genre}</td>
                              <td>{promoter.city}</td>
                              <td>
                                <a
                                  href={`http://instagram.com/${promoter.instagram_username}`}
                                  target="blank"
                                >
                                  @{promoter.instagram_username}
                                </a>
                              </td>
                              <td>{promoter.followers ? promoter.followers : '-'}</td>
                              <td>{promoter.engagement ? promoter.engagement : '-'}</td>
                              <td>{promoter.rating ? promoter.rating : '-'}</td>
                              <td>
                                <Button
                                  onClick={() => this.deleteFavorite(promoter.id)}
                                  className="btn-outline-secondary btn-small"
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">Você não possui divulgadores favoritos.</h5>
                  )}
                </div>
              </div>
            </div>
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promoters/index.js